import React, { createContext, useContext, useState, useEffect } from 'react';
import { msalInstance, loginRequest } from 'authConfig.js';

const AccessTokenContext = createContext();

export const AccessTokenProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const getToken = async () => {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          throw new Error('No accounts available');
        }

        const response = await msalInstance.acquireTokenSilent({
          scopes: loginRequest.scopes,
          account: accounts[0],
        });

        setAccessToken(response.accessToken);
      } catch (error) {
        console.error('Error acquiring token:', error);
      }
    };

    getToken();
  }, []);

  return (
    <AccessTokenContext.Provider value={{ accessToken }}>
      {children}
    </AccessTokenContext.Provider>
  );
};

export const useAccessToken = () => {
  const context = useContext(AccessTokenContext);
  if (!context) {
    throw new Error('useAccessToken must be used within an AccessTokenProvider');
  }
  return context;
};
